import { io } from 'socket.io-client';

const URL = process.env.REACT_APP_DOMAIN;

export const socket = io(URL, { autoConnect: (process.env.REACT_APP_IMPLEMENT == "HOSPITAL" ? true : false) });